import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#000";
function EVMOS({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" strokeMiterlimit={10} fill={color}><path d="M9.552 5.592c-3.81 1.468-4.16 5.23-5.252 6.987-1.106 1.778-3.639 2.758-3.293 3.664.347.906 2.883-.067 4.89.511 1.982.572 4.748 3.133 8.559 1.664a6.84 6.84 0 003.993-4.113.317.317 0 00-.267-.424.31.31 0 00-.309.17 5.408 5.408 0 01-9.731-.095q-.093-.193-.172-.397a6 6 0 01-.137-.41 62 62 0 013.966-1.681 62 62 0 013.996-1.393 45 45 0 012.21-.624l.143-.036a.206.206 0 01.242.126v.002q.033.087.062.174.197.562.296 1.131a.245.245 0 00.357.177 29 29 0 001.495-.86c1.666-1.03 2.59-1.904 2.4-2.399s-1.458-.524-3.383-.17a30 30 0 00-2.405.55q-.924.247-1.939.562a64 64 0 00-3.996 1.395 65 65 0 00-3.667 1.54 5.44 5.44 0 013.478-5.116 5.38 5.38 0 013.914.013c.12.047.256.014.344-.081a.318.318 0 00-.085-.495 6.8 6.8 0 00-5.709-.372" /></Svg>;
}
EVMOS.DefaultColor = DefaultColor;
export default EVMOS;